import styled from 'styled-components';
import AddIcon from '../../../../new-components/svg-icons/AddIcon';
import MinusIcon from '../../../../new-components/svg-icons/MinusIcon';
import ZoomButton from './ZoomButton';
import { useMap } from 'react-map-gl';
import { useEffect, useState } from 'react';
import { ZoomType } from '../../types';

const ZoomContainer = () => {
  const { current: mapRef } = useMap();

  const [zoom, setZoom] = useState(mapRef?.getZoom() || 10);

  const handleZoomIn = () => {
    if (mapRef) {
      mapRef?.zoomIn({ animate: true, essential: true, duration: 1000 });
      setZoom(mapRef?.getZoom());
    }
  };

  const handleZoomOut = () => {
    if (mapRef && zoom > mapRef.getMinZoom()) {
      mapRef?.zoomOut({ animate: true, essential: true, duration: 1000 });
      setZoom(mapRef?.getZoom());
    }
  };

  useEffect(() => {
    if (mapRef) {
      mapRef.on('zoomend', () => {
        setZoom(mapRef.getZoom());
      });
    }
  }, []);

  return (
    <Container>
      <ZoomButton
        icon={
          <AddIcon stroke="#4B535F" width="16" height="16" strokeWidth="2" />
        }
        type={ZoomType.ZoomIn}
        zoom={zoom}
        handleClick={handleZoomIn}
      />

      <div className="separator" />

      <ZoomButton
        icon={<MinusIcon strokeWidth="2" />}
        type={ZoomType.ZoomOut}
        zoom={zoom}
        handleClick={handleZoomOut}
      />
    </Container>
  );
};

const Container = styled.div`
  .separator {
    width: 100%;
    height: 1px;
    border: 1px solid #f0f1f3;
  }
`;

export default ZoomContainer;
